/* eslint-disable @typescript-eslint/typedef */

import { CartModel } from '@libs/shop/models';
import { createAction, props } from '@ngrx/store';
import { CartQueueItem } from '../state';

export const setCartId = createAction(
  '[Cart] Set Cart ID',
  props<{ id: string }>(),
);

export const loadCartId = createAction('[Cart/API] Load Cart ID');

export const loadCartIdSuccess = createAction(
  '[Cart/API] Load Cart ID Success',
  props<{ id: string }>(),
);

export const loadCartIdFailure = createAction(
  '[Cart/API] Load Cart ID Failure',
  props<{ error: Error }>(),
);

export const setCart = createAction(
  '[Cart] Set Cart',
  props<{ cartData: CartModel | undefined }>(),
);

export const loadCart = createAction('[Cart/API] Load Cart');

export const loadCartSuccess = createAction(
  '[Cart/API] Load Cart Success',
  props<{ cartData?: CartModel }>(),
);

export const loadCartFailure = createAction(
  '[Cart/API] Load Cart Failure',
  props<{ error: Error }>(),
);

export const addToCartQueue = createAction(
  '[Cart/API] Add To Cart Queue',
  props<{ payload: CartQueueItem }>(),
);

export const processCartQueue = createAction('[Cart/API] Process Cart Item');

export const cartQueueFinished = createAction('[Cart/API] Cart Queue finished');

export const cartActionSuccess = createAction(
  '[Cart/API] Cart Action Success',
  props<{ queueItem: CartQueueItem }>(),
);

export const cartActionFailure = createAction(
  '[Cart/API] Cart Action Failure',
  props<{ queueItem: CartQueueItem }>(),
);
